<form [formGroup]="userProfileForm" class="profile-form" (ngSubmit)="onSubmit()">
  <app-card [title]="'Complete User Profile'">

    <!-- Name Fields (First Name and Last Name in a single row) -->
    <div class="form-row">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Legal First Name</mat-label>
        <input matInput formControlName="firstName" placeholder="First Name" required>
        <mat-error *ngIf="userProfileForm.get('firstName')?.invalid">First Name is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Legal Last Name</mat-label>
        <input matInput formControlName="lastName" placeholder="Last Name" required>
        <mat-error *ngIf="userProfileForm.get('lastName')?.invalid">Last Name is required</mat-error>
      </mat-form-field>
    </div>

    <!-- Date of Birth Field (Full width) -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Date Of Birth</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="birthdate" placeholder="Date Of Birth" [max]="maxDate" required>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="userProfileForm.get('birthdate')?.invalid">Date of Birth is required. </mat-error>
    </mat-form-field>

    <!-- Phone Type and Phone Number (In a single row) -->
    <div class="form-row">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Type</mat-label>
        <mat-select formControlName="primaryPhoneTypeId" required>
          <mat-option value="1">Home</mat-option>
          <mat-option value="2">Work</mat-option>
        </mat-select>
        <mat-error *ngIf="userProfileForm.get('primaryPhoneTypeId')?.invalid">Phone Type is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Primary Phone Number</mat-label>
        <input matInput formControlName="phoneNumber" placeholder="Phone Number" required>
        <mat-error *ngIf="userProfileForm.get('phoneNumber')?.invalid">Please enter a valid 10-digit Phone Number. 
         </mat-error>
      </mat-form-field>
    </div>

    <!-- Update Profile Button (Submit Button) -->
    <app-card>
      <div class="submit-button">
        <button class="button-Primary" type="submit" [disabled]="userProfileForm.invalid">
          Create Profile
        </button>
      </div>
    </app-card>
  </app-card>
</form>